import { render, staticRenderFns } from "./FavouriteBtn.vue?vue&type=template&id=ea91e80a&"
import script from "./FavouriteBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FavouriteBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea91e80a')) {
      api.createRecord('ea91e80a', component.options)
    } else {
      api.reload('ea91e80a', component.options)
    }
    module.hot.accept("./FavouriteBtn.vue?vue&type=template&id=ea91e80a&", function () {
      api.rerender('ea91e80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FavouriteBtn/FavouriteBtn.vue"
export default component.exports